<textarea
  autofocus
  class="message-textarea"
  cdkTextareaAutosize
  cdkAutosizeMinRows="1"
  cdkAutosizeMaxRows="5"
  [formControl]="textControl"
></textarea>
<button mat-button color="danger" (click)="cancelChanges()" class="message-edit__cancel-btn">
  {{ 'common.cancel' | t }}
</button>
<button mat-flat-button color="success" class="save-button" (click)="saveChanges()">{{ 'common.save' | t }}</button>
